<mat-accordion>
  <mat-expansion-panel hideToggle class="custom-accordion">
    <mat-expansion-panel-header
      (click)="initializeForm(1)"
      class="mat-expansion-panel-header-overlay"
    >
      <mat-panel-title fxLayoutAlign="start center">
        Electrónica con CI
      </mat-panel-title>
      <mat-panel-description fxLayoutAlign="end center">
        <mat-icon>expand_more</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div fxLayout="row" fxLayoutAlign="center">
      <div fxLayout="column" fxFlex="40">
        <form
          name="CIForm"
          *ngIf="CIForm"
          [formGroup]="CIForm"
          (submit)="save()"
          autocomplete="off"
          #formDirective="ngForm"
        >
          <mat-form-field
            appearance="outline"
            fxLayout="column"
            fxLayoutAlign="space-around center"
            color="accent"
          >
            <mat-label>CI</mat-label>
            <input matInput formControlName="id" maxlength="10" numbersOnly />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="CINotification.id"
              [ngClass]="{ 'error-icon': controlHasError('id') }"
              >featured_play_list</mat-icon
            >
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            fxLayout="column"
            fxLayoutAlign="space-around center"
            color="accent"
            class="file-input-container"
            formFieldClickable
          >
            <mat-label>Firma</mat-label>
            <input
              matInput
              formControlName="auxiliar"
              [value]="ciSelectedFileName || ''"
              readonly
              class="custom-file-display"
              (blur)="blurFile()"
            />
            <input
              #fileInput
              type="file"
              [accept]="'.p12'"
              style="display: none"
              (click)="clickFile()"
              (change)="handleFile($event)"
            />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="CINotification.file"
              [ngClass]="{ 'error-icon': controlHasError('file') }"
              >folder</mat-icon
            >
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            fxLayout="column"
            fxLayoutAlign="space-around center"
            color="accent"
          >
            <mat-label>Password</mat-label>
            <input
              matInput
              formControlName="password"
              [type]="showPassword ? 'text' : 'password'"
              (change)="clearDueDate()"
            />
            <button
              (click)="showPassword = !showPassword"
              mat-icon-button
              matSuffix
              type="button"
              aria-label="mostrar"
              [matTooltip]="CINotification.password"
            >
              <mat-icon
                matSuffix
                class="secondary-text"
                [ngClass]="{ 'error-icon': controlHasError('password') }"
                >remove_red_eye</mat-icon
              >
            </button>
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            fxLayout="column"
            fxLayoutAlign="space-around center"
            color="accent"
          >
            <mat-label>Firma vence</mat-label>
            <input matInput formControlName="dueDate" />
            <mat-icon matSuffix class="secondary-text">calendar_today</mat-icon>
          </mat-form-field>
          <div fxLayout="column" fxLayoutAlign="space-around center">
            <button
              mat-raised-button
              color="accent"
              class="submit-button"
              aria-label="GUARDAR"
              [disabled]="CIForm.invalid || isLoading"
              color="accent"
            >
              <div *ngIf="isLoading" class="loadingComponent">
                <app-loading [isLoading]="isLoading" />
              </div>
              <span *ngIf="!isLoading">GUARDAR</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel hideToggle class="custom-accordion">
    <mat-expansion-panel-header
      (click)="initializeForm(2)"
      class="mat-expansion-panel-header-overlay"
    >
      <mat-panel-title fxLayoutAlign="start center">
        Electrónica con RUC
      </mat-panel-title>
      <mat-panel-description fxLayoutAlign="end center">
        <mat-icon>expand_more</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div fxLayout="row" fxLayoutAlign="center">
      <div fxLayout="column" fxFlex="40">
        <form
          name="RUCForm"
          *ngIf="RUCForm"
          [formGroup]="RUCForm"
          (submit)="save()"
          autocomplete="off"
          #formDirective="ngForm"
        >
          <mat-form-field
            appearance="outline"
            fxLayout="column"
            fxLayoutAlign="space-around center"
            color="accent"
          >
            <mat-label>RUC</mat-label>
            <input matInput formControlName="id" maxlength="13" numbersOnly />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="RUCNotification.id"
              [ngClass]="{ 'error-icon': controlHasError('id') }"
              >featured_play_list</mat-icon
            >
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            fxLayout="column"
            fxLayoutAlign="space-around center"
            color="accent"
            class="file-input-container"
            formFieldClickable
          >
            <mat-label>Firma</mat-label>
            <input
              matInput
              formControlName="auxiliar"
              [value]="rucSelectedFileName || ''"
              readonly
              class="custom-file-display"
              (blur)="blurFile()"
            />
            <input
              #fileInput
              type="file"
              [accept]="'.p12'"
              style="display: none"
              (click)="clickFile()"
              (change)="handleFile($event)"
            />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="RUCNotification.file"
              [ngClass]="{ 'error-icon': controlHasError('file') }"
              >folder</mat-icon
            >
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            fxLayout="column"
            fxLayoutAlign="space-around center"
            color="accent"
          >
            <mat-label>Password</mat-label>
            <input
              matInput
              formControlName="password"
              [type]="showPassword ? 'text' : 'password'"
              (change)="clearDueDate()"
            />
            <button
              (click)="showPassword = !showPassword"
              mat-icon-button
              matSuffix
              type="button"
              aria-label="mostrar"
              [matTooltip]="RUCNotification.password"
            >
              <mat-icon
                matSuffix
                class="secondary-text"
                [ngClass]="{ 'error-icon': controlHasError('password') }"
                >remove_red_eye</mat-icon
              >
            </button>
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            fxLayout="column"
            fxLayoutAlign="space-around center"
            class="backGray"
            color="accent"
          >
            <mat-label>Firma vence</mat-label>
            <input matInput formControlName="dueDate" />
            <mat-icon matSuffix class="secondary-text">calendar_today</mat-icon>
          </mat-form-field>
          <div fxLayout="column" fxLayoutAlign="space-around center">
            <button
              mat-raised-button
              color="accent"
              class="submit-button"
              aria-label="GUARDAR"
              [disabled]="RUCForm.invalid || isLoading"
              color="accent"
            >
              <div *ngIf="isLoading" class="loadingComponent">
                <app-loading [isLoading]="isLoading" />
              </div>
              <span *ngIf="!isLoading">GUARDAR</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
